import { onResponse } from 'hub-http/middlewares/core';
import { ERROR_STATUS_CODES, STATUS_CODES } from '../../constants/Http';
import { showApiAlert } from '../alerts';
import captureException from '../captureException';
import { isKnownError } from '../errors';

// to make this middleware work need to define i18n keys
// in lyaml config to show alerts
const apiAlertMiddleware = options => onResponse(response => {
  if (response.isErrorHandled || response.options.ignoreErrors) return response;
  if ((response.status > STATUS_CODES.BAD_REQUEST || response.status === STATUS_CODES.NETWORKERROR && response.errorCode !== ERROR_STATUS_CODES.ABORT) && !isKnownError(response.responseText, response.status)) {
    try {
      showApiAlert(response);
    } catch (err) {
      captureException(err);
    }
  }
  return response;
})(options);
export default apiAlertMiddleware;